<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeDrops.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeDrop"
            :options="['settings', 'export']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-drop="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeDrops.meta && representativeDrops.meta.per_page"
        layout="total, prev, pager, next"
        :total="representativeDrops.meta && representativeDrops.meta.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels, compareTypes } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      representativeDrops() {
        return this.$store.getters['representativeDrop/representativeDrops']
      },

      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeDrop/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeDrop/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeDrop/setFilterString', '');
      this.$store.commit('representativeDrop/setCurrentPage', this.currentPage);
      this.$store.commit('representativeDrop/setSorting', this.currentSort);
      await this.$store.dispatch('representativeDrop/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeDrop/setCurrentPage', val);
        this.$store.dispatch('representativeDrop/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeDrop/setSorting', { prop, order});
          this.$store.dispatch('representativeDrop/fetchAll');
        }
      },
    },
  };
</script>

